import { render, staticRenderFns } from "./settlementList.vue?vue&type=template&id=60d2cae9&scoped=true&"
import script from "./settlementList.vue?vue&type=script&lang=ts&"
export * from "./settlementList.vue?vue&type=script&lang=ts&"
import style0 from "./settlementList.vue?vue&type=style&index=0&id=60d2cae9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2cae9",
  null
  
)

export default component.exports